<script lang="ts">
	import { Mail } from 'lucide-svelte';

	interface Props {
		variant?: 'card' | 'compact' | 'sidebar';
		title?: string;
		description?: string;
	}

	let {
		variant = 'card',
		title = '📧 Stay Updated',
		description = 'Get meeting announcements and event updates delivered to your inbox.'
	}: Props = $props();

	// Variant-specific styling using derived state
	const containerClasses = $derived(
		{
			card: 'rounded-lg border border-blue-200 bg-blue-50 p-6 shadow dark:border-blue-800 dark:bg-blue-900/20',
			compact: 'rounded-lg bg-white p-6 shadow dark:bg-gray-700',
			sidebar: 'rounded-lg bg-white p-6 shadow dark:bg-gray-700'
		}[variant]
	);

	const titleClasses = $derived(
		{
			card: 'mb-2 text-lg font-semibold text-gray-900 dark:text-white',
			compact: 'mb-2 text-lg font-semibold text-gray-900 dark:text-white',
			sidebar: 'mb-2 text-lg font-semibold text-gray-900 dark:text-white'
		}[variant]
	);

	const descriptionClasses = $derived(
		{
			card: 'mb-4 text-sm text-gray-600 dark:text-gray-300',
			compact: 'mb-4 text-sm text-gray-600 dark:text-gray-300',
			sidebar: 'mb-4 text-sm text-gray-600 dark:text-gray-300'
		}[variant]
	);

	const buttonClasses = $derived(
		{
			card: 'inline-flex items-center gap-2 rounded-md bg-blue-800 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-700',
			compact:
				'inline-flex items-center gap-2 rounded-md bg-blue-800 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-700',
			sidebar:
				'inline-flex items-center gap-1 text-sm font-semibold text-blue-800 hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200'
		}[variant]
	);
</script>

<div class={containerClasses}>
	<h3 class={titleClasses}>
		{title}
	</h3>
	<p class={descriptionClasses}>
		{description}
	</p>
	<div class="space-y-2">
		{#if variant !== 'sidebar'}
			<a
				href="/newsletter"
				class="inline-flex items-center gap-1 text-sm font-semibold text-blue-800 hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200"
			>
				Learn More →
			</a>
			<br />
		{/if}
		<a
			href="https://dsarc.substack.com/subscribe"
			target="_blank"
			rel="noopener noreferrer"
			class={buttonClasses}
		>
			{#if variant === 'sidebar'}
				Go to Substack →
			{:else}
				<Mail class="h-4 w-4" />
				Subscribe Free
			{/if}
		</a>
		{#if variant === 'sidebar'}
			<br />
			<a
				href="/newsletter"
				class="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
			>
				Learn more about our newsletter →
			</a>
		{/if}
	</div>
</div>
